export default "__VITE_ASSET__xwKV1sLr__"